import { useEffect } from 'react';

const usePreventScroll = () => {
    useEffect(() => {
        const body = document.querySelector('body');
        body.style.overflow = 'hidden';

        return () => {
            body.style.removeProperty('overflow');
        };
    }, []);
};

export default usePreventScroll;
